import { ApiService } from "@/api";

export const getAllAdminQualityStatus = () => {
  return ApiService.baseAction(`/admin-quality/status/all/`, {}, "get");
};
